import actions from './actions';

const mergeEntities = actions.mergeEntities;

export default {
  mergeEntities,
};
